import {
  MaintenanceActionType,
  MaintenanceState
} from 'redux/maintenance/typings'

export const initState: MaintenanceState = {
  isLoading: false,
  shouldShowMaintenanceAlert: false,
  response: {
    maintenance: {
      underMaintenance: false,
      downTime: {
        startDateTime: '',
        stopDateTime: '',
        notificationMessage: '',
        downTimeMessage: ''
      }
    }
  },
  error: null
}

const maintenanceReducer = (
  // eslint-disable-next-line default-param-last, @typescript-eslint/default-param-last
  state: MaintenanceState = initState,
  action: MaintenanceActionType
): MaintenanceState => {
  switch (action.type) {
    case 'GET_MAINTENANCE_STATUS':
      return {
        ...state,
        isLoading: true
      }
    case 'GET_MAINTENANCE_STATUS_FULFILLED':
      return {
        ...state,
        isLoading: false,
        shouldShowMaintenanceAlert: action.payload.shouldShowMaintenanceAlert,
        response: action.payload.response
      }
    case 'GET_MAINTENANCE_STATUS_FAILED':
      return {
        ...state,
        isLoading: false,
        shouldShowMaintenanceAlert: false,
        error: action.payload.error
      }
    default:
      return state
  }
}

export default maintenanceReducer
